import { render, staticRenderFns } from "./form-beneficiaries.vue?vue&type=template&id=34dd9e0c&scoped=true"
import script from "./form-beneficiaries.vue?vue&type=script&lang=js"
export * from "./form-beneficiaries.vue?vue&type=script&lang=js"
import style0 from "./form-beneficiaries.vue?vue&type=style&index=0&id=34dd9e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dd9e0c",
  null
  
)

export default component.exports